define('services/agentDashboardAuth',[
    'services/authService',
    'services/qm/qualityAuth',
    'services/userService'
], function (
     authService,
     qualityAuthorization,
     userService
) {
    'use strict';

    //prefixes
    var PERM = "perm:";

    //domains
    var ANALYTICS_DOMAIN = PERM + "analytics:";
    var ROUTING_DOMAIN = PERM + "routing:";

    //entities
    var USERAGGREGATE_ENTITY = ANALYTICS_DOMAIN + "userAggregate:";
    var CONVERSATIONAGGREGATE_ENTITY = ANALYTICS_DOMAIN + "conversationAggregate:";
    var ROUTINGAGENT_ENTITY = ROUTING_DOMAIN + "agent:"; 

    //actions
    var VIEW = "view";
    var ONQUEUE = "onqueue";

    var agentDashboardAuth = {

        canViewWfmSchedule: function() {
            return authService.hasAuthorization({ all: ['perm:wfm:agentSchedule:view'], ignoreDivisions: true });
        },

        canViewPerformance: function() {
            return this.canViewAgentData();
        },

        canViewTimeMgmt: function() {
            return this.canViewAgentData();
        },

        canGoOnQueue: function() {
            return authService.hasAuthorization({ any: [ROUTINGAGENT_ENTITY + ONQUEUE], ignoreDivisions: true});
        },

        canViewAgentPresenceAndConversationData: function() {
            return authService.hasAuthorization({ all: [USERAGGREGATE_ENTITY + VIEW, CONVERSATIONAGGREGATE_ENTITY + VIEW], ignoreDivisions: true });
        },

        canViewAgentData: function() {
            return this.canViewAgentPresenceAndConversationData() && (qualityAuthorization.canViewEvaluation() || this.canGoOnQueue());
        },  

        canViewAgentDashboard: function() {
            // If there is no currentUser, we assume they are a trustee and should not have access to this view
            return userService.currentUser() && (this.canViewWfmSchedule() || this.canViewAgentData());
        }

    };
    return agentDashboardAuth;
});


